import Vue from 'vue'
import axios from 'axios'
// import './element.js'
import store from './../store'
import { getToken } from '@/common/utils/auth'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // api的base_url  http://novel.atxg.world:4003 'http://novel.atxg.world:4003/',//
  // timeout: 3000,// 请求超时时间
  // withCredentials: true // 允许携带cookie
})


// request拦截器
service.interceptors.request.use(
	config => {
  // if (!/form-data/.test(config.headers['Content-Type'])) {
  //   config.data = {
  //     ...config.data,
  //     _t: new Date().getTime()
  //   }

  // }
  if (store.state.token) {
    config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    // config.headers['token'] = store.getters.token // 让每个请求携带自定义token 请根据实际情况自行修改
	  config.headers['Access-Control-Allow-Headers']='*'
  }

  // return config


  return config;
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    /**
     * code为非20000是抛错 可结合自己业务进行修改
     */

    const res = response.data

    // if (res.code !== "200") {
      // Message({
      //   message: res.message,
      //   type: 'error',
      //   duration: 5 * 1000
      // })
	  // Vue.prototype.$message.error({
	  //   message: res.message,
	  //   showClose: true
	  // })
		
      // return Promise.reject('error')
    // } else {
      return response.data
    // }
  },
  error => {

    console.log('err' + error)// for debug
    // Message({
    //   message: error.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
	Vue.prototype.$message.error({
	  message: error.message,
	  showClose: true
	})
    return Promise.reject(error)
  },
)

export default service
